import { render } from "./CoverHeader.vue?vue&type=template&id=009771d9"
import script from "./CoverHeader.vue?vue&type=script&lang=js"
export * from "./CoverHeader.vue?vue&type=script&lang=js"

import "./CoverHeader.vue?vue&type=style&index=0&id=009771d9&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__